import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import { actionTypes } from "./ChurchVideoActions";
import {
    saveChurchVideo,
    updateChurchVideo,
    deleteChurchVideo,
    readChurchVideos
  } from "./churchVideoAPI";
  

// SAVE
function* saveSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveChurchVideo, apiPayloadRequest);

    if (res.type === 1) {
      yield put({ type: actionTypes.SAVE_CHURCH_VIDEO_SUCCESS, payload: res.data });
      toast.success(res.message || "Saved!");
      action.callback?.({ type: 1, data: res.data });
    } else {
      throw new Error(res.error);
    }
  } catch (err) {
    yield put({ type: actionTypes.SAVE_CHURCH_VIDEO_FAILURE, payload: err.message });
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// UPDATE
function* updateSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateChurchVideo, apiPayloadRequest);

    if (res.type === 1) {
      yield put({ type: actionTypes.UPDATE_CHURCH_VIDEO_SUCCESS, payload: res.data });
      toast.success(res.message || "Updated!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (err) {
    yield put({ type: actionTypes.UPDATE_CHURCH_VIDEO_FAILURE, payload: err.message });
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// DELETE
function* deleteSaga(action) {
  try {
    const res = yield call(deleteChurchVideo, action.payload);

    if (res.type === 1) {
      yield put({
        type: actionTypes.DELETE_CHURCH_VIDEO_SUCCESS,
        payload: action.payload,
      });
      toast.success(res.message || "Deleted!");
      action.callback?.({ type: 1 });
    } else throw new Error(res.error);
  } catch (err) {
    yield put({ type: actionTypes.DELETE_CHURCH_VIDEO_FAILURE, payload: err.message });
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// READ
function* readSaga(action) {
  try {
    const res = yield call(readChurchVideos, action.payload);

    if (res.type === 1) {
      yield put({ type: actionTypes.READ_CHURCH_VIDEO_SUCCESS, payload: res.data });
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (err) {
    yield put({ type: actionTypes.READ_CHURCH_VIDEO_FAILURE, payload: err.message });
    action.callback?.({ type: 0, error: err.message });
  }
}

// WATCHER (default export FIX)
export default function* churchVideoWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CHURCH_VIDEO_REQUEST, saveSaga);
  yield takeLatest(actionTypes.UPDATE_CHURCH_VIDEO_REQUEST, updateSaga);
  yield takeLatest(actionTypes.DELETE_CHURCH_VIDEO_REQUEST, deleteSaga);
  yield takeLatest(actionTypes.READ_CHURCH_VIDEO_REQUEST, readSaga);
}
